import useChartType from './useChartType';
import dentalPlugin from '../plugins/dental';

/**
 * ChartSlot — the centralised mount point for the active specialty's
 * chart. Sits inside `DoctorQueueView` (active-visit branch) alongside
 * the `WidgetHost`. ChartSlot picks the right plugin and renders its
 * `Component`. Today only the dental plugin exists; when ortho / neuro
 * / ENT ship, they register at the manifest layer and this file does
 * NOT change (one-line plugin lookup is already generic).
 *
 * MVP scope note
 * --------------
 * The dental chart is currently ALSO mounted by `OdontogramSection`
 * (inside the procedure rail) and by `ToothFindingsSummary` (inside
 * the visit form) — those are the legacy entry points the doctors
 * already rely on. Centralising the mount to a single ChartSlot is
 * a follow-up cleanup; for MVP, this slot exists as the architectural
 * artifact (so future specialty plugins have a clear home) and
 * `OdontogramSection` / `ToothFindingsSummary` continue to mount the
 * chart for their own event-driven open/close flows. Rendering null
 * here keeps the visible behaviour identical to today.
 */
const PLUGINS_BY_SPECIALTY = {
  dental: dentalPlugin,
};

export default function ChartSlot(/* { visit, viewer } */) {
  const chartType = useChartType();
  const plugin = chartType ? PLUGINS_BY_SPECIALTY[chartType] : null;

  if (!plugin) return null;

  // PR 4/5 cleanup will route the legacy entry-point events
  // (arogya:open-tooth-chart) through ChartSlot and the existing
  // OdontogramSection / ToothFindingsSummary mounts will be removed.
  // Until then this slot is intentionally inert.
  return null;
}
